// Registers the service worker (production only) and reports when a new
// version is installed and waiting, so the app can offer a reload. It never
// reloads by itself: swapping versions mid-service could blank the screen.

const listeners = new Set();
let waitingRegistration = null;

/** Subscribe to "a new version is ready". Calls back immediately if one already is. */
export function onUpdateReady(fn) {
  listeners.add(fn);
  if (waitingRegistration) fn(waitingRegistration);
  return () => listeners.delete(fn);
}

function announce(registration) {
  waitingRegistration = registration;
  listeners.forEach((fn) => fn(registration));
}

function watch(registration) {
  // Already installed and waiting (e.g. found on a previous visit).
  if (registration.waiting && navigator.serviceWorker.controller) announce(registration);

  registration.addEventListener('updatefound', () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener('statechange', () => {
      // "installed" with an existing controller = an update, not the first install.
      if (worker.state === 'installed' && navigator.serviceWorker.controller) announce(registration);
    });
  });
}

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then(watch)
      .catch((error) => console.error('Service worker registration failed:', error));
  });
}

/** Activate the waiting version and reload once it has taken over. */
export function applyUpdate(registration = waitingRegistration) {
  if (!registration || !registration.waiting) {
    window.location.reload();
    return;
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}
